window.goldlog = window.goldlog || {};
window.goldlog.record = window.goldlog.record || function () { };

// 只接受string类型
export default function log(ext, key) {
  let content = '';
  if (window.dmtrack_pageid) {
    content = `st_page_id=${window.dmtrack_pageid}&ext=${encodeURIComponent(ext)}`
  } else {
    content = `ext=${encodeURIComponent(ext)}`;
  }
  if (key) {
    window['goldlog'].record(key, 'CLK', content, 'GET');
  } else {
    window.goldlog.record('/sc.ma.log', 'CLK', content, 'H1448248720');
  }
}

function getKey() {
  let key = '/sc.ma.log';
  const pathname = window.location.pathname;

  if (pathname.indexOf('messenger.htm') !== -1) {
    key = '/sc.ma.messenger';
  }
  if (pathname.indexOf('weblite.htm') !== -1) {
    key = '/sc.ma.weblite';
  }
  return key;
}

// 内部打点方法
export function _log(ext) {
  window['goldlog'].record(getKey(), 'CLK', `${window.dmtrack_pageid ? `st_page_id=${window.dmtrack_pageid}&` : ''}ext=${encodeURIComponent(ext)}`, 'GET');
}
